/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { discountItemSchema } from "./discountItemSchema.ts";

export const calculateDiscountItemModifierSchema = z
	.object({
		id: z.uuid(),
		amount: z.int().min(1),
		size: z.uuid().nullish(),
		marking_code: z.string().nullish(),
		price: z.string(),
		base_price: z.string().describe("Цена за единицу без акции блюда; совпадает с price, если акции нет."),
		total_price: z.string(),
		new_price: z.string(),
		total_new_price: z.string(),
		discounts: z.array(discountItemSchema).nullable(),
		free_amount: z.int(),
	})
	.describe("Базовый сериализатор рассчета скидки по позициям.");
